var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFixedTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5125 26.6583C12.5125 28.0333 13.625 29.1458 15 29.1458C16.375 29.1458 17.4875 28.0333 17.4875 26.6583H12.5125ZM15 7.89575C18.45 7.89575 21.25 10.6958 21.25 14.1458V22.8958H8.75V14.1458C8.75 10.6958 11.55 7.89575 15 7.89575ZM15 2.27075C13.9625 2.27075 13.125 3.10825 13.125 4.14575V5.60825C9.2 6.45825 6.25 9.95825 6.25 14.1458V21.6458L3.75 24.1458V25.3958H26.25V24.1458L23.75 21.6458V14.1458C23.75 9.95825 20.8 6.45825 16.875 5.60825V4.14575C16.875 3.10825 16.0375 2.27075 15 2.27075ZM13.75 10.3958H16.25V15.3958H13.75V10.3958ZM13.75 17.8958H16.25V20.3958H13.75V17.8958Z",
    fill: "#805AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFixedTickets);
export default __webpack_public_path__ + "static/media/Not FixedTickets.4f7d3602c881ad8627a8e33151344e89.svg";
export { ForwardRef as ReactComponent };